import { sendActionLog } from '../sendActionLog'

const PAGE_ID = '/picka_menu'

export const sidebarActionLog = {
  inital: async () => {
    await sendActionLog({
      pageId: PAGE_ID,
    })
  },
  clickLogin: async () => {
    await sendActionLog({
      pageId: PAGE_ID,
      actionId: 'click_login',
    })
  },
  clickNotice: async () => {
    await sendActionLog({
      pageId: PAGE_ID,
      actionId: 'click_notice',
    })
  },
  clickFaq: async () => {
    await sendActionLog({
      pageId: PAGE_ID,
      actionId: 'click_faq',
    })
  },
}
